import React from 'react'
import { FormSelectSales } from 'src/components/form-elements/custom-form-select.SalesSettings.component'
import { GetTranslation } from 'src/services/fleet-translation-http.service'
import { makeStyles } from '@material-ui/core/styles';

const useSelectStyles = makeStyles((theme) => ({
    SelectControl: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        minWidth: "100%",
    },
}));

const EngineSelect = ({ onChange, variant, value, placeholder }) => {
    const [engine, setEngine] = React.useState([]);
    const [open, setOpen] = React.useState(false);
    const classes = useSelectStyles();

    React.useEffect(() => {
        selectVehicleColor();
    }, []);

    const selectVehicleColor = () => {
        let engineArray = [];

        GetTranslation(['ENGINETYPE'])
            .then(data => {
                Array.isArray(data) && data.length > 0 ? data.map(engine => {
                    engineArray.push({ key: engine.fleetValue, value: engine.integratorValue });
                })
                    : console.log("Error Occured");
                setEngine(engineArray);
            });
    }

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    return (
        <FormSelectSales
            className={classes.SelectControl}
            label="Engine"
            id="engineType"
            name={''}
            open={open}
            onOpen={handleOpen}
            onClose={handleClose}
            value={value}
            onChange={onChange}
            menuObjectArray={engine}
            variant={variant ? variant : false}
            placeholder={placeholder}
        />
    )
}

export default EngineSelect;